import { useState, useEffect } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { DonorService } from "../../Services/Donor.Service";

function RaceEthnicity({ userData, raceData, singleHeritage, dualHeritage, setToastMessage, setToastVariant, setShowToast,setLoading }) {
  const [typeId, setTypeId] = useState(""); // 1 = single, 2 = dual
  const [raceSingleHeritage, setRaceSingleHeritage] = useState("");
  const [raceDualHeritage, setRaceDualHeritage] = useState([]);
  const [error, setError] = useState(null);

  // Prefill values if coming from API
useEffect(() => {
  if (userData?.race_data && Array.isArray(userData?.race_data)) {
    const typeIdFromApi = userData.race_data[0]?.type_id || "";

    setTypeId(typeIdFromApi);

    if (typeIdFromApi === 1) {
      // Single heritage: just one race_id
      setRaceSingleHeritage(userData.race_data[0]?.race_id || "");
      setRaceDualHeritage([]);
    } else if (typeIdFromApi === 2) {
      // Dual heritage: multiple race_ids
      setRaceSingleHeritage("");
      setRaceDualHeritage(userData.race_data.map((r) => r.race_id));
    }
  }
}, [userData]);


  const handleCheckboxChange = (raceId, checked) => {
    setRaceDualHeritage((prev) =>
      checked ? [...prev, raceId] : prev.filter((id) => id !== raceId)
    );
  };

  const updateRaceEthnicity = async () => {
    // Clear old error
    setError(null);
    // Basic validations
    if (!typeId) {
      setError("Please select heritage type");
      return;
    }

    if (typeId === 1 && !raceSingleHeritage) {
      setError("Please select an option for Single Heritage.");
      return;
    }

    if (typeId === 2 && raceDualHeritage.length === 0) {
      setError("At least one option must be selected from the Dual Heritage.");
      return;
    }
    setLoading(true);

    const payload = {
      user_id: userData.id,
      race_type_id: String(typeId),
      race_ethnicity_ids:
        typeId === 1 ? [raceSingleHeritage] : raceDualHeritage,
    };

    try {
      const response = await DonorService.saveRaceEthnicity(payload, userData?.race_data.length > 0); // pass true if updating
      setLoading(false);
      setToastMessage(response.message);
      setToastVariant("success");
      setShowToast(true);

    } catch (err) {
      setLoading(false);
      console.error("Error updating Race/Ethnicity", err);
      setToastMessage(err.message);
      setToastVariant("error");
      setShowToast(true);
    }
  };

  return (
    <div className="el-bg-table el-super-admin mt-3 ">
      <Accordion alwaysOpen defaultActiveKey={["1"]} flush>
        <Accordion.Item eventKey="1">
          <Accordion.Header className="cursor-pointer">
            <b>Race/Ethnicity</b>
          </Accordion.Header>
          <Accordion.Body>
            <container className="el-property-details-card-content">
              <Row>
                <Col md={12} className="mx-fit-content">
                  {raceData && (
                    <div>
                      {/* Heritage Type */}
                      <div className="mb-3"> 
                        <div className="d-flex justify-content-start mt-3   mb-2">
                             <h6 className="form-label me-3">
                          <b>Select Heritage Type</b> <span className="text-red">*</span>
                        </h6>
                          {[1, 2].map((id) => (
                            <div className="form-check mb-2 me-2" key={id}>
                              <input
                                type="radio"
                                name="type_id"
                                id={`type_id_${id}`}
                                value={id}
                                checked={String(typeId) === String(id)}
                                onChange={(e) => {
                                  setTypeId(Number(e.target.value));
                                  setError(null);
                                }}
                                className="form-check-input dashboard-card-count"
                              />
                              <label
                                htmlFor={`type_id_${id}`}
                                className="form-check-label dashboard-card-count"
                              >
                                &nbsp; {id === 1 ? "Single Heritage" : "Dual Heritage"}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Single Heritage */}
                      {typeId === 1 && singleHeritage && (
                        <div className="mb-3">
                          <h6 className="form-label mb-4">
                            <b>{singleHeritage.type_title}</b> (select one)
                          </h6>
                          {singleHeritage?.race_options?.map((race) => (
                            <div key={race.race_id} className="form-check form-check-profile-setting-race-ethnicity">
                              <input
                                type="radio"
                                name="raceSingleHeritage"
                                id={`raceSingleHeritage_${race.race_id}`}
                                value={race.race_id}
                                checked={raceSingleHeritage === race.race_id}
                                onChange={() => {
                                  setRaceSingleHeritage(race.race_id);
                                  setRaceDualHeritage([]); // clear dual if switching
                                  setError(null);
                                }}
                                className="form-check-input dashboard-card-count"
                              />
                              <label
                                htmlFor={`raceSingleHeritage_${race.race_id}`}
                                className="form-check-label dashboard-card-count ms-3"
                              >
                                {race.heritage_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Dual Heritage */}
                      {typeId === 2 && dualHeritage && (
                        <div className="mb-3">
                          <h6 className="form-label mb-4">
                            <b>{dualHeritage.type_title}</b> (select multiple)
                          </h6>
                          {dualHeritage?.race_options?.map((race) => (
                            <div key={race.race_id} className="form-check form-check-profile-setting-race-ethnicity">
                              <input
                                type="checkbox"
                                id={`raceDualHeritage${race.race_id}`}
                                value={race.race_id}
                                checked={raceDualHeritage.includes(race.race_id)}
                                onChange={(e) => {
                                  handleCheckboxChange(race.race_id, e.target.checked);
                                  setError(null);
                                }}
                                className="form-check-input dashboard-card-count"
                              />
                              <label
                                htmlFor={`raceDualHeritage${race.race_id}`}
                                className="form-check-label dashboard-card-count"
                              >
                                {race.heritage_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {error && <div className="text-danger">{error}</div>}
                    </div>
                  )}
                </Col>
              </Row>
            </container>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="d-flex align-items-center mt-3">
        <button onClick={updateRaceEthnicity} className="el-main-button me-3">
          <span>Save Changes</span>
        </button>
      </div>
    </div>
  );
}

export default RaceEthnicity;
